<template>
	<div class="AppWoowGraph">
		<div ref="AppWoowGraph" style="width: 100%; height: 450px;" />
		<!-- <hr>
    series == {{ graphSeries }}
    <hr>
    yaxis -- {{ graphYaxis }}
    <hr>
    {{ graphData }} -->
	</div>
</template>
<script>
var echarts = require("echarts");
import { GraphData } from "../../../../mixins/graphData.js";
import { converters } from "../../../../mixins/converters";
import { EventBus } from "../../../eventBus";
import { mapGetters } from "vuex";
export default {
	name: "AppWoowGraphV2",
	mixins: [GraphData, converters],
	data() {
		return {
			woowGraphInstance: null,
			seriesObj: {
				name: "Sales",
				type: "bar",
				barGap: 0.2,
				// label: labelOption,
				data: [],
				// itemStyle: {
				// 	color: "#fcebea",
				// 	borderColor: "#f9acaa"
				// },
				label: {
					show: true,
					formatter: "{c}",
					color: "#000",
					fontSize: 12
				}
			},
			selectedViewMapping: {
				sale: "SALES",
				at: "AT",
				adt: "ADT",
				ipt: "IPT",
				iplh: "TXNS"
			}
		};
	},

	computed: {
		...mapGetters(["getNameOfGraph", "getGraphVisibility", "getGraphRerenderStatus"]),
		showAnalyticsDataOnGraph() {
			return this.$store.getters.getGraphData;
		},

		selectedView() {
			// console.log("getselectSalesView", this.$store.getters.getselectSalesView);
			return this.$store.getters.getselectSalesView;
		}
	},

	watch: {
		getGraphVisibility(newValue, oldValue){
			console.log('getGraphVisibility', newValue);
			// if (!newValue) {
			// 	// this.initWoowGraph();
			// 	this.reRenderOneBarGraph();
			// } else {
			// 	}
			this.reRenderOneBarGraph();
		},
		getGraphRerenderStatus(newValue, oldValue){
			// if(newValue){
				this.initWoowGraph();
				this.reRenderGraph();
			// }
		}
	},

	mounted() {
		this.initWoowGraph();
		// console.log("graphseries", this.graphSeries);
		// EventBus.$on("callRerender", router => {
		// 	this.initWoowGraph();
		// 	console.log("calling reRender()", router);
		// 	this.reRenderGraph(router);
		// });

		// EventBus.$on("callReRenderOneBarGraph", graph => {
		// 	console.log("graph", graph);
		// 	if (!graph) {
		// 		this.initWoowGraph();
		// 		this.reRenderOneBarGraph();
		// 	} else {
		// 		this.reRenderOneBarGraph();
		// 		this.clearGraph();
		// 	}
		// });
	},

	// beforeDestroy(){
	// 	EventBus.$off('callReRenderOneBarGraph');
	// 	EventBus.$off('callReRenderOneBarGraph');
	// },

	methods: {
		initWoowGraph() {
			let woowGraphContainer = this.$refs["AppWoowGraph"];
			this.woowGraphInstance = echarts.init(
				woowGraphContainer,
				null,
				this.initOptions
			);
			// this.woowGraphInstance.showLoading();
		},

		clearGraph() {
			// console.log("clearing woowGraphInstance");
			this.woowGraphInstance.clear();
			// console.log("this.woowGraphInstance", this.woowGraphInstance);
		},

		SeriesFields: function() {
			(this.name = ""),
				(this.type = ""),
				(this.barGap = 0.2),
				// label: labelOption,
				(this.data = [])
				// (this.itemStyle = {
				// 	color: "#fcebea",
				// 	borderColor: "#f9acaa"
				// });
			// (this.label = {
			// 	show: true,
			// 	formatter: "{c}",
			// 	color: "#000",
			// 	fontSize: 12
			// });
		},

		YaxisFields: function(formatter) {
			(this.type = "value"),
				(this.name = ""),
				// interval: 100,
				(this.axisLabel = {
					formatter: "{value}"
				});
		},

		getCurrentGrpahSeriesVar() {
			var grpahSeriesVar = [];
			if (this.$route.name === "Report") {
				grpahSeriesVar = [
					{
						name: "Achieved Transactions",
						type: "bar",
						data: this.showAnalyticsDataOnGraph.series.achivedTransactions,
						// itemStyle: {
						// 	color: "#ffd5e3",
						// 	borderColor: "#f9acaa"
						// }
					},
					// {
					// 	name: "Forecast Transaction",
					// 	type: "bar",
					// 	data: this.showAnalyticsDataOnGraph.series.forecastTransaction,
					// 	itemStyle: {
					// 		color: "#ffbcd2",
					// 		borderColor: "#ff89b0"
					// 	}
					// },
					{
						name: "Achieved Iplh",
						type: "bar",
						data: this.showAnalyticsDataOnGraph.series.achivedIplh,
						// itemStyle: {
						// 	color: "#cffffd",
						// 	borderColor: "#5be5e0"
						// },
						yAxisIndex: 1
					},
					{
						name: "Target Iplh",
						type: "bar",
						data: this.showAnalyticsDataOnGraph.series.targetIplh,
						// itemStyle: {
						// 	color: "#f2d024"
						// },
						yAxisIndex: 1
					}
				];
			}
			if (this.$route.name === "StoreType") {
				grpahSeriesVar = [
					{
						name: "Achieved Iplh",
						type: "bar",
						data: this.showAnalyticsDataOnGraph.series.achivedIplh,
						// itemStyle: {
						// 	color: "#cffffd",
						// 	borderColor: "#5be5e0"
						// },
						yAxisIndex: 1
					},
					{
						name: "Target Iplh",
						type: "bar",
						data: this.showAnalyticsDataOnGraph.series.targetIplh,
						// itemStyle: {
						// 	color: "#f2d024"
						// },
						yAxisIndex: 1
					}
				];
			}
			if (this.$route.name === "Location" || this.$route.name === "Category") {
				grpahSeriesVar = [
					{
						name: "This Year",
						type: "bar",
						data: this.showAnalyticsDataOnGraph.series.thisYear,
						// itemStyle: {
						// 	color: "#ffd5e3",
						// 	borderColor: "#f9acaa"
						// }
					},
					{
						name: "Last Year",
						type: "bar",
						data: this.showAnalyticsDataOnGraph.series.lastYear,
						// itemStyle: {
						// 	color: "#ffbcd2",
						// 	borderColor: "#ff89b0"
						// }
					},
					{
						name: "Forecast",
						type: "bar",
						data: this.showAnalyticsDataOnGraph.series.target,
						// itemStyle: {
						// 	color: "#cffffd",
						// 	borderColor: "#5be5e0"
						// }
					} // removed trend line from graph
					// {
					// 	name: "YoY %",
					// 	type: "line",
					// 	data: this.showAnalyticsDataOnGraph.series.growth,
					// 	itemStyle: {
					// 		color: "#f2d024"
					// 	},
					// 	yAxisIndex: 1
					// }
				];
			}
			return grpahSeriesVar;
		},

		reRenderGraph() {
			this.clearGraph();
			if (this.$route.name === "Category") {
				this.graphXaxis.axisLabel.rotate = 20;
			}

			this.graphXaxis.data = this.showAnalyticsDataOnGraph.xAxisData;
			let graphYaxisVars = [
				{
					name: this.$route.name === "StoreType" ? "" : this.selectedViewMapping[this.selectedView]
				},
				{
					name: this.$route.name === "Report" ? "IPLH" : this.$route.name === "Location" || this.$route.name === "Category" ? "YoY %" : "",
					formatter: "{value} %"
				}
			];

			this.graphYaxis = [];

			graphYaxisVars.map(obj => {
				let newYaxisFields = new this.YaxisFields();
				let addToGraphDataYaxis = Object.assign(newYaxisFields, obj);
				// console.log("addToGraphDataYaxis", addToGraphDataYaxis);
				this.graphYaxis.push(addToGraphDataYaxis);
			});

			var graphSeriesVars = this.getCurrentGrpahSeriesVar(this.$route.name);
			// console.log("graphSeriesvars", graphSeriesVars);
			this.graphSeries = [];

			graphSeriesVars.map(obj => {
				let newSeriesFieldsObj = new this.SeriesFields();
				let addToGraphDataSeries = Object.assign(newSeriesFieldsObj, obj);
				// console.log("addToGraphDataSeries in mapper", addToGraphDataSeries);
				this.graphSeries.push(addToGraphDataSeries);
			});

			this.woowGraphInstance.setOption(this.graphData);
			this.woowGraphInstance.hideLoading();
		},

		reRenderOneBarGraph() {
			this.clearGraph();
			this.graphXaxis.data = this.showAnalyticsDataOnGraph.xAxisData;
			let graphYaxisVars = [
				{
					name: this.selectedViewMapping[this.selectedView]
				}
			];
			// console.log("this.graphYaxis abouve", this.graphYaxis);
			this.graphYaxis = [];
			// console.log("this.graphYaxis below", this.graphYaxis);
			graphYaxisVars.map((obj, i) => {
				let newYaxisFields = new this.YaxisFields();
				let addToGraphDataYaxis = Object.assign(newYaxisFields, obj);
				// console.log("addToGraphDataYaxis", addToGraphDataYaxis);
				// this.graphYaxis.push(addToGraphDataYaxis);
				this.$set(this.graphYaxis, i, addToGraphDataYaxis);
			});
			let graphSeriesVars = [
				{
					name: this.selectedViewMapping[this.selectedView],
					type: "bar",
					data: this.showAnalyticsDataOnGraph.series.seriesYaxis,
					// itemStyle: {
					// 	color: "#fcebea",
					// 	borderColor: "#f9acaa"
					// }
				}
			];
			this.graphSeries = [];
			graphSeriesVars.map((obj, i) => {
				let newSeriesFieldsObj = new this.SeriesFields();
				let addToGraphDataSeries = Object.assign(newSeriesFieldsObj, obj);
				// this.graphSeries.push(addToGraphDataSeries);
				this.$set(this.graphSeries, i, addToGraphDataSeries);
			});
			// console.log("this.graphSeries", this.graphSeries);
			this.woowGraphInstance.setOption(this.graphData);
			this.woowGraphInstance.hideLoading();
		}
	},
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/variable.scss";
.AppWoowGraph {
	background: #fff;
	border-radius: $app-border-radius;
	box-shadow: $app-card-shadow;
	margin: 0.5rem 0;
	padding: 1rem 0;
	overflow: hidden;
}
.AppWoowGraph .WoowGraph {
	// height: 300px !important;
}
</style>
<style>
tspan {
	text-transform: capitalize;
}
</style>
